function smoothScrollIntoView(target, duration = 600) {
    const startY = window.scrollY;
    let targetY;
    // Determine target position based on input type
    if (typeof target === 'number') {
        targetY = target;
    }
    else if (target instanceof HTMLElement) {
        targetY = target.getBoundingClientRect().top + window.scrollY;
    }
    else {
        console.error('Invalid target provided. Expected HTMLElement or number.');
        return;
    }
    const distance = targetY - startY;
    const startTime = performance.now(); // wrap this in lower environment
    // if user has reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.scrollTo(0, targetY);
        return;
    }
    function scrollStep(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1); // Clamp between 0 and 1
        // Ease-in-out function for smoother motion
        const ease = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
        window.scrollTo(0, startY + distance * ease);
        if (elapsed < duration) {
            requestAnimationFrame(scrollStep);
        }
    }
    requestAnimationFrame(scrollStep);
}

export { smoothScrollIntoView };
